import ApiService from '@/services/core/api.service'

const CompanyService = {
  async get (query) {
    return ApiService.get(`user/companies?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/companies', payload)
  },

  async put (payload) {
    return ApiService.put(`user/companies/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/companies/${payload.id}`)
  }
}

export default CompanyService
